import { createContext } from "react";

// Create the context
const AppContext = createContext();

export default AppContext;
